import { Box, Typography, Button, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import useMediaQuery from "@mui/material/useMediaQuery";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useEffect } from "react";

import LoadingButton from "@mui/lab/LoadingButton";
import { useNavigate } from "react-router-dom";

const CreditCardSucces = ({ state }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	// const isNonMobile = useMediaQuery("(min-width: 800px)");
	const MySwal = withReactContent(Swal);
	const navigate = useNavigate();

	const handleFinal = async () => {
		try {
			console.log("finalizado");
		} catch (err) {
			console.log("error pegar dados: ", err);
		}
		navigate("/");
	};

	useEffect(() => {
		MySwal.fire({
			icon: "success", 
			title: "Feito", 
			text: `Transação confirmada!! Comprovante enviado para:  ${state.creditCardHolderInfo.email}`, 
			footer: 'Caso o cliente não receba o comprovante, falar com o financeiro@pitayajoias.com.br',
			confirmButtonText: 'Finalizar'
		}).then((result) => {
			if(result.isConfirmed) {
				navigate("/");
			}
		});
	}, []);

	return (
		<Box
			display="flex"
			justifyContent="center"
			flexDirection="column"
			alignItems="center"
			sx={{
				width: "100%",
				'& .swal2-footer': {
					color: 'blue !important'
				}
			}}
		>
			<LoadingButton
				loading={false}
				type="submit"
				sx={{
					backgroundColor: colors.greenAccent[600],
					// width: isNonMobile ? "50%" : "80%",
					width: "100%",
					borderRadius: "60px"
				}}
				variant="contained"
				onClick={handleFinal}
				// disabled={isValid}
			>
				Finalizar
			</LoadingButton>
		</Box>
	);
};

export default CreditCardSucces;
